import React from "react";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import DBLogo from "../assets/images/dentalbot_mini.png";
import "./index.scss";
import { useTranslation } from "../i18n";

const StepControls = ({
  title,
  icon,
  subTitle,
  subTitleIcon,
  nextKey,
  nextTitle,
  goBack,
  isBackBtnDisabled,
  goForward,
  isNextBtnDisabled,
  onSave
}) => {
  const {
    _t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("div", {
    className: `stepControls ${subTitle ? "extraPadding" : ""}`
  }, /*#__PURE__*/React.createElement("button", {
    className: `stepControls-btn back ${isBackBtnDisabled ? "hidden" : ""}`,
    onClick: goBack
  }, /*#__PURE__*/React.createElement(DoubleArrowIcon, null), /*#__PURE__*/React.createElement("span", null, _t("Назад"))), /*#__PURE__*/React.createElement("div", {
    className: "stepControls-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "stepControls-info-logo"
  }, /*#__PURE__*/React.createElement("img", {
    src: icon ? icon : DBLogo,
    alt: ""
  })), /*#__PURE__*/React.createElement("div", {
    className: "stepControls-info-title"
  }, title), subTitle && /*#__PURE__*/React.createElement("div", {
    className: "stepControls-info-subTitle"
  }, subTitleIcon && /*#__PURE__*/React.createElement("img", {
    src: subTitleIcon,
    className: "subTitleIcon",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "subTitleText",
    dangerouslySetInnerHTML: {
      __html: subTitle
    }
  }))), /*#__PURE__*/React.createElement("button", {
    className: `stepControls-btn next ${!nextKey || isNextBtnDisabled ? "hidden" : ""} ${nextKey === "save" ? "save" : ""}`,
    onClick: () => {
      if (nextKey === "save") {
        onSave();
        return;
      }

      goForward(nextKey);
    },
    disabled: !nextKey || isNextBtnDisabled
  }, /*#__PURE__*/React.createElement("span", null, nextTitle || _t("Далее")), /*#__PURE__*/React.createElement(DoubleArrowIcon, null)));
};

export default StepControls;